import * as React from 'react';
import { useFormContext, Controller, ValidationRule } from 'react-hook-form';
import ImagePicker, { IProps as IComponentProps } from 'client/components/Form/ImagePicker';
import get from 'lodash/get';

interface IProps extends Omit<IComponentProps, 'errors' | 'onChange'> {
  name: string;
  validate?: ValidationRule;
}

const FormImagePicker: React.FC<IProps> = ({ name, validate, ...imagePickerProps }) => {
  const { control, formState: { errors } } = useFormContext();

  return (
    <Controller
      rules={validate}
      name={name}
      control={control}
      render={({ field }) => (
        <ImagePicker
          name={name}
          {...imagePickerProps}
          initialValue={field.value}
          onChange={field.onChange}
          errors={get(errors, name)}
        />
      )}
    />
  );
};

export default FormImagePicker;
